<template>
<div style="background-color: white">
	<link href="https://cdn.jsdelivr.net/npm/bootstrap-italia@1.6.4/dist/css/bootstrap-italia.min.css" rel="stylesheet">
	
  <v-alert v-if="alertType" :type="alertType" :value="true" outlined>
    <span v-html="message"></span>
  </v-alert>

  <header class="it-header-wrapper">
    <div class="it-nav-wrapper">
	    <div class="it-header-center-wrapper">
		    <div class="container-fluid">
			    <div class="row">
				    <div class="col-8">
					    <div class="it-header-center-content-wrapper">
						    <div class="it-brand-wrapper">
							    <a href="#">
								    <img src='/img/logo-vim.svg' class="logo-h">
								    <div class="it-brand-text">
									    <h2 class="no_toc">Ministero dello sviluppo economico</h2>
									    <h3 class="no_toc d-none d-md-block">Voucher Innovation Manager</h3>
								    </div>
							    </a>
						    </div>
					    </div>
				    </div>
				    <div class="col-4">
					    <div>
						    <input
							    @click="computedClienteClickdayIt ? popUpDatiCliccatore() : showDatiCliccatore()"
							    type="button"
							    value="Finestra Dati Personali"
							    class="btn btn-sm custom-btn dati-personali mb-2"
							    style="color: white"
						    >
					    </div>
					    <div>
						    <input
							    @click="isSimulazioneGuidata || simulazioniTerminate ? goBack() : abbandona()"
							    :disabled="isLeftingSimulazione"
							    type="button"
							    :value="`${simulazioniTerminate ? 'Torna alla Home' : 'Abbandona simulazione'}`"
							    class="btn btn-sm custom-btn abbandona simulazione-step-8"
							    style="color: white"
						    >
					    </div>
				    </div>
			    </div>
		    </div>
	    </div>
    </div>
  </header>

  <main id="page-content">
    <div class="my-4 simulazione-step-2 ">

      <template v-if="status == 'not_started'">
        <div class="container">
	        <h2>
		        Non è ancora possibile eseguire l'invio.
	        </h2>
	        
	        <div
		        class="my-4 font-weight-bold"
		        style="font-size:18px; width: auto;"
	        >
		        <!-- <div style="color:#002e5f;">La simulazione inizierà alle ore <span data-tour-step="1">{{getTimeByDatetime(simulazione.data_ora)}}</span></div> -->
		        <div style="color:#002e5f;">La simulazione inizierà alle ore <span class="pa-1 simulazione-step-1">{{ orarioSimulazione }}</span></div>
		        <div class="error--text" >Aggiornare la pagina premendo ripetutamente F5 su Windows o Mela+R su MAC</div>
	        </div>
	        
	        <div :style="`color:${scdOrange}; font-size:18px;`" class="mt-6 font-weight-bold">
		        I dati necessari per la simulazione sono nella finestra dei dati personali, clicca il pulsante arancione in alto per aprirla
	        </div>
        </div>
      </template>



      <template v-else-if="status == 'started'">
	      <h2 class="text-uppercase font-weight-bold text-center pt-16 pb-12">
		      VOUCHER PER CONSULENZA IN INNOVAZIONE (SECONDO SPORTELLO)
	      </h2>
	      <!--<p style="font-size: 18px">-->
		    <!--  Per inviare la domanda di accesso alle agevolazioni inserire i dati richiesti. <br>-->
		    <!--  Si ricorda che l'invio è consentito dalle ore 12:00 del 29 novembre 2023. <br>-->
		    <!--  La domanda di agevolazione si intende correttamente trasmessa esclusivamente a seguito del rilascio da parte della procedura informatica dell'attestazione di avvenuta presentazione.-->
	      <!--</p>-->
	      <br>
	      
				<v-form ref="formEseguiSimulazione">
          <input type="hidden" name="_token" :value="csrf">
					
          <div class="simulazione-step-3 simulazione-step-5">
            <div
              v-for="(sim, index) in datiSimulazione.simulazione"
              :id="sim.uuid"
              :key="sim.uuid"
              :class="`row d-flex justify-content-center`"
            >
	            <div class="col-12 col-md-12 col-lg-6 col-sm-12">
		            
		            <template v-if="sim.tipo == 'textvimnum' && sim.show">
			            <div class="form-group">
				            <span :class="`label-style ${sim.rispostaNonCorretta ? 'errore ' : ''}`">
					            {{ sim.domanda }}
				            </span>
				            <div class="input-group">
					            <div class="input-group-prepend">
						            <div class="input-group-text" style="padding-right: 0px">
							            <b>
								            <a style="color: #5d7083;">VIM-2_</a>
							            </b>
						            </div>
					            </div>
					            <input
						            v-model="risposteUtente[sim.uuid]"
						            type="text"
						            :name="`risposte[${index}]`"
						            minlength="8"
						            maxlength="8"
						            size="15"
						            pattern="[0-9]{8,8}$"
						            autocomplete="off"
						            class="form-control"
					            >
				            </div>
			            </div>
		            </template>
		            
		            <template v-else-if="sim.tipo == 'textvimchar' && sim.show">
			            <div class="form-group">
				            <span :class="`label-style ${sim.rispostaNonCorretta ? 'errore ' : ''}`">
					            {{ sim.domanda }}
				            </span>
				            <div class="input-group">
					            <div class="input-group-prepend">
						            <div class="input-group-text" style="padding-right: 0px">
							            <b>
								            <a style="color: #5d7083;">VIM-2_</a>
							            </b>
						            </div>
					            </div>
					            <input
						            v-model="risposteUtente[sim.uuid]"
						            type="text"
						            :name="`risposte[${index}]`"
						            :minlength="sim.risposte[0].length"
						            :maxlength="sim.risposte[0].length"
						            size="15"
						            pattern="[0-9]{8,8}$"
						            autocomplete="off"
						            class="form-control"
					            >
				            </div>
				            
				            <!--<div>-->
					            <!--<input-->
						          <!--  v-model="risposteUtente[sim.uuid]"-->
						          <!--  type="text"-->
						          <!--  :name="`risposte[${index}]`"-->
						          <!--  :minlength="sim.risposte[0].length"-->
						          <!--  :maxlength="sim.risposte[0].length"-->
						          <!--  size="15"-->
						          <!--  pattern="[0-9]{8,8}$"-->
						          <!--  autocomplete="off"-->
					            <!--&gt;-->
					            <!--<small-->
						          <!--  style="font-size: 13px"-->
						          <!--  class="text-muted"-->
					            <!--&gt;-->
						          <!--  {{ `Immettere il codice predisposizione senza 'VIM-2_' (${sim.risposte[0].length} caratteri)` }}-->
					            <!--</small>-->
				            <!--</div>-->
			            </div>
		            </template>
		            
		            <template v-else-if="sim.tipo == 'monochar' && sim.show">
			            <span :class="`label-style ${sim.rispostaNonCorretta ? 'errore ' : ''}`">
				            {{ sim.domanda }}
			            </span>
			            <div class="form-row">
				            <template v-for="(char, index) of sim.risposte[0]">
					            <div class="col-auto">
						            <input
							            @input="handleMonochar(index, $event.data, sim)"
							            type="text"
							            minlength="1"
							            maxlength="1"
							            size="1"
							            pattern="[A-Za-z0-9]{1,1}$"
						            >
					            </div>
				            </template>
			            </div>
		            </template>
		            
		            <div
			            v-else-if="sim.tipo == 'text' && sim.show"
			            class="form-group"
		            >
			            <span :class="`label-style ${sim.rispostaNonCorretta ? 'errore ' : ''}`">
				            {{ sim.domanda }}
			            </span>
			            <input
				            v-model="risposteUtente[sim.uuid]"
				            type="text"
				            :name="`risposte[${index}]`"
				            class="form-control"
				            autocomplete="off"
			            >
		            </div>
		            
		            <div v-else-if="sim.tipo == 'radio' && sim.show">
			            <span :class="`label-style ${sim.rispostaNonCorretta ? 'errore ' : ''}`">
				            {{ sim.domanda }}
			            </span>
			            <div
				            v-for="(risposta, index) in sim.risposte"
				            class="form-check"
			            >
				            <input
					            v-model="risposteUtente[sim.uuid]"
					            :id="`radio_${index}_${sim.uuid}`"
					            :name="`radio_${sim.uuid}`"
					            type="radio"
					            :value="risposta"
				            >
				            <label :for="`radio_${index}_${sim.uuid}`">{{ risposta }}</label>
			            </div>
		            </div>
		            
		            <div v-else-if="sim.tipo == 'select' && sim.show">
			            <div class="select-wrapper">
				            <span :class="`label-style ${sim.rispostaNonCorretta ? 'errore ' : ''}`">
					            {{ sim.domanda }}
				            </span>
				            <select
					            @input="risposteUtente[sim.uuid] = $event.target.value"
					            :name="`risposte[${index}]`"
				            >
					            <option
						            value=""
						            selected=""
					            >
						            Scegli una risposta
					            </option>
					            <option
						            v-for="(risposta, i) in sim.risposte"
						            :key="i"
						            :value="risposta"
					            >
						            {{risposta}}
					            </option>
				            </select>
			            </div>
		            </div>
		            
		            <div v-else-if="sim.tipo == 'checkbox' && sim.show">
			            <div class="form-check">
				            <input
					            v-model="risposteUtente[sim.uuid]"
					            :id="`checkbox_${sim.uuid}`"
					            type="checkbox"
				            >
				            <label
					            :for="`checkbox_${sim.uuid}`"
					            :class="`label-style ${sim.rispostaNonCorretta ? 'errore ' : 'bla'}`"
				            >
					            {{ sim.domanda }}
				            </label>
			            </div>
		            </div>
		            
		            <div v-else-if="sim.tipo == 'data' && sim.show">
			            <span :class="`label-style ${sim.rispostaNonCorretta ? 'errore ' : ''}`">
				            {{ sim.domanda }}
			            </span>
			            <input
				            v-model="risposteUtente[sim.uuid]"
				            type="date"
				            :name="`risposte[${index}]`"
				            autocomplete="off"
			            >
			            <!--style="width: 200px;"-->
		            </div>
		            
	            </div>
	            
              <!--<label-->
              <!--  v-if="sim.tipo != 'checkbox' && sim.show"-->
              <!--  style="color: black;"-->
              <!--  class="font-weight-bold mb-0"-->
              <!--&gt;-->
							<!--	{{ sim.domanda }}-->
							<!--</label>-->

            </div>
          </div>
          
          <div
	          class="mt-9 d-flex justify-content-center"
	          style="margin-bottom: 150px"
          >
            <!--<input-->
	          <!--  v-if="tastoIndietroVisibile"-->
	          <!--  @click="setDomandeESchermataDaMostrare('indietro')"-->
	          <!--  type="button"-->
	          <!--  value="Indietro"-->
	          <!--  title="Indietro"-->
	          <!--  class="btn btn-primary simulazione-step-7"-->
	          <!--  tabindex="3"-->
            <!--&gt;-->

            <input
	            type="button"
	            v-show="tastoContinuaVisibile"
	            @click="eseguiSimulazione(false, 'avanti')"
	            value="Continua"
	            class="btn btn-outline-primary py-2 simulazione-step-4"
            >
	          
            <input
	            type="button"
	            v-show="tastoInviaVisibile"
	            @click="eseguiSimulazione(true)"
	            :disabled="eseguitaSimulazioneConGuida || simulazioniTerminate"
	            value="Invia"
	            class="btn btn-outline-primary simulazione-step-6 "
            >

          </div>
        </v-form>
	      
        <div v-if="eseguitaSimulazioneConGuida" class="page-overlay"></div>

        <v-dialog
	        persistent
	        v-model="eseguitaSimulazioneConGuida"
	        max-width="504px"
        >
          <v-col
	          class="pa-4 white--text"
	          style="background-color:#002e5f"
          >
            <span class="title">
              Complimenti, hai completato la guida!
            </span>
              <br><br>
            <span class="title">
              Adesso clicca su OK per tornare alla Pagina Iniziale ed eseguire la tua prima vera simulazione!
            </span>
            <div class="ok-button-wrapper">
              <a
	              class="ok-button"
	              href="/home"
              >
	              OK
              </a>
            </div>
          </v-col>
        </v-dialog>
      </template>
      
    </div>
  </main>
	
	<footer class="it-footer" id="sticky-footer">
		<div class="it-footer-main">
			<div class="container">
				<section>
					<div class="row clearfix">
						<div class="col-sm-12">
							<div class="it-brand-wrapper">
								<a href="#">
									<img src='img/logo-vim.svg' class="logo-b">
									<div class="it-brand-text">
										<h2 class="no_toc">Ministero dello sviluppo economico</h2>
										<h3 class="no_toc d-none d-md-block">Voucher Innovation Manager</h3>
									</div>
								</a>
							</div>
						</div>
					</div>
				</section>
				<section>
					<div class="row">
						<div class="col-lg-6 col-md-6 col-sm-6 pb-2">
							<h4>
								<a href="#" title="Vai alla pagina: Contatti">Contatti </a>
							</h4>
							<div class="link-list-wrapper">
								<ul class="footer-list link-list clearfix">
									<li><a class="list-item" href="#" title="Contattaci">managerinnovazione.istanzedgiai@mise.gov.it</a></li>
									<li><span class="list-item">06 64892998 (lunedì-venerdì 9:00-17:00)</span></li>
								</ul>
							</div>
						</div>
						<div class="col-lg-6 col-md-6 col-sm-6">
							<h4>
								<a href="#" title="Vai alla pagina: Documenti">Documenti</a>
							</h4>
							<div class="link-list-wrapper">
								<ul class="footer-list link-list clearfix">
									<li><a class="list-item" target="_blank" href="#" title="Vai alla pagina: Istruzioni operative">Istruzioni operative</a></li>
									<li><a class="list-item" target="_blank" href="#" title="Vai alla pagina: Scheda su Voucher per Consulenza in innovazione">Scheda su Voucher per Consulenza in innovazione</a></li>
									<!--<li><a class="list-item" href="https://www.mise.gov.it/index.php/it/assistenza/domande-frequenti/2040160-voucher-per-consulenza-in-innovazione-domande-frequenti-faq" title="Vai alla pagina: FAQ">FAQ</a></li>-->
								</ul>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
		<div class="it-footer-small-prints clearfix">
			<div class="container">
				<h3 class="sr-only">Sezione Link Utili</h3>
				<ul class="it-footer-small-prints-list list-inline mb-0 d-flex flex-column flex-md-row">
					<li class="list-inline-item">
						<a class="nav-link" href="#" target="_blank">Privacy policy</a>
					</li>
				</ul>
			</div>
		</div>
	</footer>

  <v-tour name="explanatoryTour" :steps="tourSteps" :options="tourOptions" :callbacks="tourCallbacks">
    <template slot-scope="tour">
      <transition name="fade">
        <v-step
          v-if="tour.currentStep === index"
          v-for="(step, index) of tour.steps"
          :key="index"
          :step="step"
          :previous-step="tour.previousStep"
          :next-step="tour.nextStep"
          :stop="tour.stop"
          :is-first="tour.isFirst"
          :is-last="tour.isLast"
          :labels="tour.labels"
          style="max-width: 600px"
          :highlight="tour.highlight"
        >
        </v-step>
      </transition>
    </template>
  </v-tour>

  <v-dialog v-model="isDatiCliccatoreDialogOpen" width="920">
    <v-card min-width=900 max-width=900>
      <v-card-title class="headline">
        <!-- <span class="ml-4">DATI CLICCATORE</span> -->
        <v-spacer></v-spacer>
        <v-btn color="black--text" icon @click="isDatiCliccatoreDialogOpen = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div :style="`margin:0 10px 20px; color:${scdOrange}; font-weight:500;`">
          ATTENZIONE:<br>Questa finestra contiene i dati personali che possono essere richiesti durante le simulazioni. Devi quindi copiarli e incollarli in un blocco note per averli a portata di mano durante gli allenamenti.
        </div>
        <dati-cliccatore-component v-if="isDatiCliccatoreDialogOpen" :IdUtenteProp="computedIdUtente"/>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="scdColor" style="text-transform:none; padding:0 20px; color:white;" depressed rounded class="mr-4 mb-3" @click="isDatiCliccatoreDialogOpen = false">Chiudi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <ricariche-component :toggleDialog="isDialogAcquistoRicaricheAperta" @chiudiDialog="chiudiDialogAcquistoRicariche($event)"></ricariche-component>
	
</div>
</template>

<script>
import mixin from '../../mixins';
import { uuid } from 'vue-uuid';
export default {
  data() {
    return {
      alertType: null,
      message: null,
      
      valid: false,

      idCliccatore: this.computedIdUtente,

      isCliente: false,
      isProvaGratuita: false,
      isCliccatore: false,

      isLeftingSimulazione: false,

      status: null,

      datiSimulazione: {
        id: null,
        dataOra: null,
        simulazione: [],
        // startIndex: 0,
        // endIndex: null,
        simulazioneGuidata: false
      },
      schermataAttuale: 0,
      maxSchermate: 0,

      simulazioniTerminate: false,
	    
	    bando: null,

      risposteUtente: {
        // Le informazioni inserite dall'utente
        // Verranno identificate attraverso un uuid generato nella funzione getDatiSimulazione()

        // uuid (stringa) : risposta dell'utente (stringa)
        // "3df85a92-a0f1-4ca3-9b4a-8b67e91cc467" : risposta
      },
      // A causa della diversa formattazione della data, metto qua le risposte pronte ad essere confrontate con quelle del database
      risposteUtentePerIlConfronto: {

      },

      tastoContinuaVisibile: true,
      tastoIndietroVisibile: false,
      tastoInviaVisibile: false,

      // Inserisco il Csrf Token presente nei META
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),

      // Tour guidato al primo accesso:
      eseguitaSimulazioneConGuida: false,

      tourSteps: [],
      tourOptions: {
          useKeyboardNavigation: false,
          labels: {
              buttonSkip: 'Salta guida',
              buttonPrevious: 'Precedente',
              buttonNext: 'Successivo',
              buttonStop: 'Fine'
          },
          highlight: true
      },
      tourCallbacks: {
        onPreviousStep: this.vaiAllaPaginaPrecedente,
        onNextStep: this.vaiAllaPaginaSuccessiva,
        onStop: this.utentePuoInteragire
      },
      currentStep: 2,
      tourInEsecuzione: false,

      ripetiGuida: false,

      isDatiCliccatoreDialogOpen: false,

      isDialogAcquistoRicaricheAperta: false,
	    
	    // risposteMonochar: {}
    };
  },

  created() {
    // this.getDatiSimulazione();
  },

  mounted() {
    this.getDatiSimulazione();
	  
	  let scriptTag = document.createElement("script");
	  scriptTag.src = "https://cdn.jsdelivr.net/npm/bootstrap-italia@1.6.4/dist/js/bootstrap-italia.bundle.min.js";
	  scriptTag.id = "bootstrap-1-6-4";
	  document.getElementsByTagName('head')[0].appendChild(scriptTag);
  },

  methods: {
    getDatiSimulazione() {
      axios
      .get('/ottieniSimulazione')
      .then(response => {
        this.datiSimulazione.id = response.data.simulazione.id;
        this.datiSimulazione.dataOra = response.data.simulazione.dataOra;
        this.datiSimulazione.simulazioneGuidata = response.data.simulazione.simulazioneGuidata;
        this.datiSimulazione.simulazioneConRisposteSenzaShuffle = response.data.simulazione.simulazioneConRisposteSenzaShuffle; // copia esatta del database
        this.datiSimulazione.simulazione = response.data.simulazione.simulazione;
        this.maxSchermate = response.data.simulazione.maxSchermate;
        this.simulazioniTerminate = response.data.simulazione.simulazioniTerminate;

        this.datiSimulazione.simulazione.forEach(domanda => {
          domanda.uuid = this.$uuid.v4(); // assegno un id univoco ad ogni domanda
          // nell'oggetto delle risposte da inviare per il controllo, per ogni domanda creo una chiave univoca con lo stesso nome dell'id creato nella riga precedente
					if (domanda.tipo == 'checkbox') this.risposteUtente[domanda.uuid] = false
					else if (domanda.tipo == 'monochar') {
						this.risposteUtente[domanda.uuid] = '';
						domanda.risposteMonochar = {};
						for (let i = 0; i < domanda.risposte[0].length; i++) {
							domanda.risposteMonochar[i] = null;
						}
						// console.log(domanda.risposteMonochar)
					}
					else this.risposteUtente[domanda.uuid] = null;
          domanda.rispostaNonCorretta = false;
          domanda.show = false;
        });

        this.status = response.data.status;
        this.bando = response.data.bando;

        this.schermataAttuale = 0;
        if (this.status == 'started') {
          this.setDomandeESchermataDaMostrare('avanti');
        }

        this.startSimulazioneTour();

        if (this.simulazioniTerminate && !this.datiSimulazione.simulazioneGuidata) {
          this.mostraBannerSimulazioniTerminate();
        }
      })
    },
    setDomandeESchermataDaMostrare(direzione) {
      this.setSchermataAttuale(direzione);

      let maxCicliEmergenza = 0;
      let domandeTrovatePerSchermataAttuale = false;
      while (!domandeTrovatePerSchermataAttuale) {
        for (let i = 0; i < this.datiSimulazione.simulazione.length; i++) {
          if (this.datiSimulazione.simulazione[i].schermata == this.schermataAttuale) {
            this.datiSimulazione.simulazione[i].show = true;
            domandeTrovatePerSchermataAttuale = true;
          } else if (this.datiSimulazione.simulazione[i].schermata != this.schermataAttuale) {
            this.datiSimulazione.simulazione[i].show = false;
          }
        }

        if (!domandeTrovatePerSchermataAttuale) {
          this.setSchermataAttuale(direzione);
        }

        // visibilità pulsanti
        if (this.schermataAttuale > 1) {
          this.tastoIndietroVisibile = true;
        } else if (this.schermataAttuale == 1) {
          this.tastoIndietroVisibile = false;
        }

        if (this.schermataAttuale == this.maxSchermate) {
          this.tastoContinuaVisibile = false;
          this.tastoInviaVisibile = true;
        } else if (this.schermataAttuale < 3) {
          this.tastoContinuaVisibile = true;
          this.tastoInviaVisibile = false;
        }

        maxCicliEmergenza++;
        if (maxCicliEmergenza == 50) {
          break;
        }

      }
    },
    setSchermataAttuale(direzione) {
      if (direzione == 'avanti' && this.schermataAttuale < this.maxSchermate) {
        this.schermataAttuale++;
      } else if (direzione == 'indietro' && this.schermataAttuale > 1) {
        this.schermataAttuale--;
      }
    },
    tornaAllaPrimaSchermata() {
      this.schermataAttuale = 0;
      this.setDomandeESchermataDaMostrare('avanti');
    },
    goBack: function(){
      // Torna semplicemente indietro: disponibile quando sto visualizzando la guida
      window.location.href = "/home#/";
    },
    abbandona: function() {
      // Avviso il server di segnare la simulazione come abbandonata, e poi torno indietro
      this.isLeftingSimulazione = true;

      axios
        .get(`/simulazioni/${this.datiSimulazione.id}/${this.bando.id}/${this.annoMeseGiornoSimulazione}/abbandona`)
        .then(response => {
          window.location.href = "/home#/";
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.isLeftingSimulazione = false;
        });
    },
    eseguiSimulazione: function(inviaForm, direzione) {
      if (this.tourInEsecuzione) {
        return;
      }

      if (this.simulazioniTerminate) {
        this.setDomandeESchermataDaMostrare(direzione);
        return;
      }
      
      let errorFound = false;

      let risposteCorrette = {};
      
      // creo un oggetto con le risposte corrette
      // uuid (stringa) : risposta (number)
      for (const key in this.datiSimulazione.simulazione) {
        let UUIDSimulazione = this.datiSimulazione.simulazione[key].uuid;

        risposteCorrette[UUIDSimulazione] = this.datiSimulazione.simulazioneConRisposteSenzaShuffle[key].risposte[0];

        if (this.datiSimulazione.simulazione[key].tipo == 'data' && moment(this.risposteUtente[UUIDSimulazione], "YYYY-MM-DD", true).isValid()) {
          this.risposteUtentePerIlConfronto[UUIDSimulazione] = moment(this.risposteUtente[UUIDSimulazione], "YYYY-MM-DD").format('DD/MM/YYYY');
        } else {
          this.risposteUtentePerIlConfronto[UUIDSimulazione] = this.risposteUtente[UUIDSimulazione];
        }
      }

      // console.log(this.risposteUtentePerIlConfronto);

      // confronto le risposte dell'utente e le risposte corrette
      var indexSimulazione = 0;
      for (const uuid in this.risposteUtentePerIlConfronto) {
        const rispostaUtente = this.risposteUtentePerIlConfronto[uuid];
	      
	      // console.log(rispostaUtente, risposteCorrette[uuid]);
        // se la risposta dell'utente e quella corretta non combaciano e la domanda è renderizzata, c'è un errore
        if(rispostaUtente != risposteCorrette[uuid] && this.datiSimulazione.simulazione[indexSimulazione].show == true) {
          errorFound = true;
          this.datiSimulazione.simulazione[indexSimulazione].rispostaNonCorretta = true;
          this.$forceUpdate();

        } else {
          this.datiSimulazione.simulazione[indexSimulazione].rispostaNonCorretta = false;
          this.$forceUpdate();
        }
        indexSimulazione++;
      }
	    
	    console.log(errorFound)

      if (!inviaForm && !errorFound) {
        // this.toggleDomande();
        this.setDomandeESchermataDaMostrare(direzione);
        return;
      }

      if (!errorFound) {
        // Se sono in modalità GUIDA, non proseguire a mostrare il risultato!
        if (this.isSimulazioneGuidata && inviaForm) {
          this.eseguitaSimulazioneConGuida = true;
          this.$tours['explanatoryTour'].stop();
          return;
        }

        let formData = new FormData();
        formData.append('risposte', JSON.stringify(this.risposteUtentePerIlConfronto));
        formData.append('simulazione_id', this.datiSimulazione.id);
        formData.append('bando_id', this.bando.id);
        formData.append('anno_mese_giorno_simulazione', this.annoMeseGiornoSimulazione);
        axios
        .post('/risultato',
          formData,       
          {
            headers: {
                'Content-Type': 'application/json'
            },
          }
        )
        .then(response => {
          let risultatoSimulazione = {
              bandoId: this.bando.id,
              provaGratuita: response.data.provaGratuita,
              countAltriUtenti: response.data.countAltriUtenti,
              minimoAltriUtenti: response.data.minimoAltriUtenti,
              tempoImpiegato: response.data.tempoImpiegato,
              colore: response.data.colore,
              hasError: response.data.hasError,
              message: response.data.message,
            } 

          localStorage.setItem('risultatoSimulazioneVim', JSON.stringify(risultatoSimulazione));

          this.$router.push({ 
            name: `risultato-${this.bando.route}`,
            params: risultatoSimulazione
          });
        })
      }
        
    },
    // toggleDomande(saltaCodice) {
    //   if (saltaCodice) {
    //     return;
    //   }

    //   for (const key in this.datiSimulazione.simulazione) {
    //     this.datiSimulazione.simulazione[key].show = !this.datiSimulazione.simulazione[key].show;
    //   }

    //   this.tastoContinuaVisibile = !this.tastoContinuaVisibile;
    //   this.tastoIndietroVisibile = !this.tastoIndietroVisibile;
    //   this.tastoInviaVisibile = !this.tastoInviaVisibile;
    // },
    getTimeByDatetime: function(datetime) {
      return datetime.split(" ")[1];
    },
    openGuide() {
      this.ripetiGuida = true;
      if (this.tastoInviaVisibile) { // se il tasto invia è visibile vuol dire che sono nella seconda schermata e lo riporto nella prima
        this.toggleDomande();
      }
      this.startSimulazioneTour();
      // this.$tours['explanatoryTour'].start();
    },
    startSimulazioneTour() {
      // Se il parametro "Guida" è nell'URL allora avvio la guida
      if(this.isSimulazioneGuidata || this.ripetiGuida){
        this.tourInEsecuzione = true;
        
        if(this.status == 'not_started'){
          this.tourSteps = [
            {
              target: '.simulazione-step-1',
              content: `Eccoci alla tua prima Simulazione!<br>Appena si avvicina l'orario indicato, aggiorna la pagina<br>(per farlo velocemente premi 'F5' su Windows o 'Mela+R' su MAC)`
            }
          ];
        } else { // Se la simulazione è partita e la Guida è richiesta mostro questo:
          this.tourSteps = [
              {
                target: '.simulazione-step-2',
                content: `La simulazione è divisa in più pagine, ogni pagina ti chiederà di compilare dei campi`,
                params: {
                  placement: 'top'
                }
              },
              {
                target: '.simulazione-step-3',
                content: `Questa è la prima serie di campi,<br>presta molta attenzione a cosa c'è scritto.`,
                params: {
                  placement: 'top'
                }
              },
              {
                target: '.simulazione-step-4',
                content: `Questo bottone ti permette di visualizzare la seconda pagina, 
                ma solamente se avrai compilato correttamente i campi in questa pagina.`,
                params: {
                  placement: 'left-end'
                }
              },
              {
                target: '.simulazione-step-5',
                content: `Ora siamo nella seconda pagina e questa è la seconda serie di campi`,
                params: {
                  placement: 'top'
                },
                // before: promise => new Promise((resolve, reject) => {
                //   // Time-consuming UI/async operation here
                //   let response = this.eseguiSimulazione(false, true);
                //   if (response == 'pagina successiva') {
                //     resolve(response);
                //   }
                // })
                // .then(() => {
                //   this.toggleDomande();
                //   console.log('then');
                // })
              },
              {
                target: '.simulazione-step-6',
                content: `Questo bottone ti permette di eseguire la simulazione, 
                sempre dopo aver correttamente compilato i campi`,
                params: {
                  placement: 'top-end'
                }
              },
              {
                target: '.simulazione-step-7',
                content: `Questo bottone ti permette di tornare alla pagina precedente`,
                params: {
                  placement: 'top-start'
                }
              },
              {
                target: '.simulazione-step-8',
                content: `Se vuoi abbandonare la simulazione usa questo bottone.<br><br>
                Ricorda che il giorno del vero Click Day non potrai tornare indietro se l’invio della domanda è difficile, avrai una sola chance. Per cui ti consigliamo di non abbandonare mai le simulazioni ma di allenarti a superarle tutte!<br><br>
                Ora tocca a te, cliccando su Fine tornerai alla prima pagina e potrai svolgere questa simulazione di prova!`,
                params: {
                  placement: 'left-start'
                }
              },
            ]     
        }

        setTimeout(() => {
          this.$tours['explanatoryTour'].start();
        }, 10);
      }
    },
    vaiAllaPaginaPrecedente() {
      this.currentStep--;
      if (this.currentStep == 4) {
        this.setDomandeESchermataDaMostrare('indietro');
      }
    },
    vaiAllaPaginaSuccessiva() {
      this.currentStep++;
      if (this.currentStep == 5) {
        this.setDomandeESchermataDaMostrare('avanti');
      }
    },
    utentePuoInteragire() {
      this.tourInEsecuzione = false;
      this.tornaAllaPrimaSchermata();
    },

    mostraBannerSimulazioniTerminate() {
      if (window.__NOME_PACCHETTO__ == 'PROVAGRATUITA') {
        this.isProvaGratuita = true;
      } else if (window.__NOME_PACCHETTO__ != 'PROVAGRATUITA' && window.__RUOLO__ == 'Admin') {
        this.isCliente = true;
      } else if (window.__NOME_PACCHETTO__ != 'PROVAGRATUITA' && window.__RUOLO__ != 'Admin') {
        this.isCliccatore = true;
      }
    },
    apriPaginaPacchetti() {
      window.open('https://simulatoreclickday.it/acquista/');
    },
    apriDialogAcquistoRicariche() {
      this.isDialogAcquistoRicaricheAperta = true;
    },
    chiudiDialogAcquistoRicariche() {
      this.isDialogAcquistoRicaricheAperta = false;
    },
    showDatiCliccatore(idCliccatore) {
      this.idCliccatoreToShowDati = idCliccatore;
      this.isDatiCliccatoreDialogOpen = true;
    },
	  handleMonochar(index, char, domandaObj) {
		  domandaObj.risposteMonochar[index] = char || '';
		  this.risposteUtente[domandaObj.uuid] = '';
		  for (const index in domandaObj.risposteMonochar) {
			  if (domandaObj.risposteMonochar[index] !== null) {
				  this.risposteUtente[domandaObj.uuid] += domandaObj.risposteMonochar[index];
			  }
		  }
	  }
  },
  computed: {
    orarioSimulazione() {
      return moment(this.datiSimulazione.dataOra, "YYYY-MM-DD hh:mm:ss").format('HH:mm:ss');
    },
    annoMeseGiornoSimulazione() {
      return moment(this.datiSimulazione.dataOra, "YYYY-MM-DD hh:mm:ss").format('YYYY-MM-DD');
    },
    isSimulazioneGuidata() {
      return this.datiSimulazione.simulazioneGuidata;
    },

    // localIdSimulazione () {
    //   return localStorage.getItem('idSimulazione');
    // },
    // localDataOraSimulazione () {
    //   return localStorage.getItem('dataOra');
    // },
  }
};
</script>

<!--<style scoped src="../../../css/bootstrap-italia.min.css"></style>-->

<style lang="scss" scoped>
	* {
		font-family: "Titillium Web",Geneva,Tahoma,sans-serif !important;
	}

	::v-deep {
		.v-input--checkbox label {
			color: black !important;
			font-size: 14px !important;
			font-family: 'Open Sans', sans-serif !important;
		}
	}
	
  fieldset {
    margin: 0;
    padding: 0;
    border: 0;
  }
  
  .mr-15 {
      margin-right: 15px;
  }
  .form-elem {
    margin-bottom: 20px;
  }
  //.form-elem .msg {
  //  position: relative;
  //  top: 5px;
  //  display: none;
  //}
  //.form-elem input:not([type="checkbox"]),
  //.form-elem label input:not([type="radio"]),
  //.form-elem select {
  //  width: 100%;
  //  border: 1px solid #afafaf;
  //  background-color: #fff;
  //  height: 34px;
  //  box-sizing: border-box;
  //  padding: 6px 12px;
  //}
  //.form-elem input:focus,
  //.form-elem select:focus {
  //  outline: 0;
  //  border-color: #66afe9;
  //  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6);
  //}
  //.form-elem label {
  //  margin-bottom: 5px;
  //  display: inline-block;
  //}
  
  //.errore input:focus,
  //.errore select:focus {
  //  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px #ce8483;
  //}
  .errore input,
  .errore select {
    border-color: #bc2025;
    /* border-color: #C9291B; */
  }
  .errore.label-style {
    color: #bc2025 !important;
    /* color: #C9291B; */
  }
  .form-elem.date-elem label {
    display: block;
  }
  .form-elem.date-elem input{
      width: 200px;
  }
  
  .custom-btn {
	  text-transform: uppercase;
	  font-size: 12px !important;
	  padding: 5px 10px !important;
	  line-height: 1.5;
	  &.abbandona {
		  background-color: #bc2025;
	  }
	  &.dati-personali {
		  background-color: #e6901c;
	  }
  }
  //.btn-row {
  //  height: 80px;
  //  margin-top: 40px;
  //}
  .btn[disabled] {
    pointer-events: none;
    cursor: not-allowed;
    box-shadow: none;
    background: #d2d2d2;
    border-color: #d2d2d2;
    color: #002e5f;
    opacity: 1 !important;
  }

  //.btn:focus, input[type=checkbox]:focus, .feedback:focus {
  //  outline: thin dotted;
  //  outline-offset: -2px;
  //}
  //input[type=checkbox] {
  //  margin: 0;
  //  margin-right: 5px;
  //  top: 3px;
  //  position: relative;
  //}
  .pull-right {
    float: right;
  }
  .xs-12 {
    width: 100%;
  }

  //::v-deep ._radio_group label,
  //::v-deep ._checkbox label {
  //  animation: none !important;
  //}

  /*SM*/
  @media (min-width: 768px) {}
  /*MD*/
  @media (min-width: 992px) {
    .md-6 {
       width: 50%;
    }
  }

  /*LG*/
  @media (min-width: 1200px) {}
  .loader-overlay {
    position: fixed;
    background-color: #002E5F;
    background-color: rgba(0, 46, 95, 0.2);
    width:100%;
    height:100%;
    top:0;
    left: 0;
    opacity: 1;
    z-index: 500000;
  }
  .loader-overlay span{
    position: fixed; /* or absolute */
    top: 50%;
    left: 50%;
    border: 10px solid #106CDB; /* Light grey */
    border-top: 10px solid #002e5f; /* Blue */
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 2s linear infinite;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .data-summary strong {
      width: 200px;
      display: inline-block;
  }

  .avviso-finale-prova {
    position: absolute;
    bottom: 200px;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .page-overlay {
    position: absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    background-color: rgba(0, 0, 0, 0.50);
  }

  .tour-2-3 {
    width: 100%;
  }
  @media (min-width: 992px) {
    .tour-2-3 {
      width: 50%;;
    }
  }

  .ok-button-wrapper {
    display: flex;
    justify-content: flex-end;
    padding-top: 20px;
  }
  .ok-button {
    color: #002e5f;
    font-size: 20px;
    text-decoration: none;
    padding: 5px 10px;
    background-color: white;
    border-radius: 3px;
  }
	
	/* VIM */
 .logo-b {
	 width: 60px;
	 margin-right: 15px;
 }
 
 .logo-h {
	 width: 90px;
	 margin-right: 25px;
	 margin-bottom: 15px;
 }
 a.navbar-brand {
	 white-space: normal;
	 text-align: center;
	 word-break: break-all;
 }
 
 .sticky-offset{
	 top: 80px;
 }
 
 /* Sticky footer styles
-------------------------------------------------- */
  html {
	  font-size: 14px;
	  position: relative;
	  min-height: 100%;
  }
  @media (min-width: 768px) {
	  html {
		  font-size: 16px;
		  position: relative;
		  min-height: 100%;
	  }
  }
  
  @media(max-width: 768px) {
	  .dx-menu {
		  display: none;
	  }
  }
  
  @media(max-width: 990px) {
	  .it-nav-wrapper img {
		  width: 60px;
		  margin-right: 15px;
	  }
  }
  
  
  button.accept-policy {
	  font-size: 1rem;
	  line-height: inherit;
  }
  
  html,
  body {
	  height: 100%;
  }
  
  #page-content {
	  flex: 1 0 auto;
  }
  
  #sticky-footer {
	  flex-shrink: none;
  }
	
	.label-style {
		font-size: .777rem;
		font-weight: bold;
		color: #1a1a1a;
	}
	/* END VIM */
</style>


<!--ultima versione di bootstrap italia -->
<!--<style scoped src="../../../css/bootstrap-italia.min.css"></style>-->

<!-- css preso dallo sorso vim, bootstrap versione 1.3.5-->
<!--<style scoped src="./bootstrap-vim/bootstrap-italia.min.css"></style>-->